module.exports = __webpack_public_path__ + "img/support.5b10f508.svg";